import React, {useState} from "react";
import Captcha from "../../component/Captcha";
import Footer from "../../component/Footer";
import "./iletisim.css";
import LoadingIndicator from "../../component/LoadingIndicator";
import {register} from "../../util/APIUtils";
import ReactHtmlParser from "react-html-parser";
import {VirtualHost} from "../../constants";

function ContactUs() {
  const [message, setMessage] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!loading) {
      setLoading(true);

      const data = {
        message: message,
        nameSurname: nameSurname,
        email: email,
        phone: phone
      };

      register(JSON.stringify(data)).then((response) => {
        setLoading(false);
        setMessage("");
        setPhone("");
        setEmail("");
        setNameSurname("");

        const elementById = document.getElementById("u-form-send-success");
        elementById.style.display = "block";
        setTimeout(() => {
          elementById.style.display = "none";
        }, 5000);
      }).catch((error) => {
        setLoading(false);
        const elementById = document.getElementById("u-form-send-error");
        elementById.style.display = "block";
        setTimeout(() => {
          elementById.style.display = "none";
        }, 5000);
      });
    }
  }

  const validate = () => {

  }

  return (
    <div>
      <section className="u-clearfix u-section-1" id="sec-415a">
        <div className="u-clearfix u-sheet u-valign-bottom u-sheet-1">
          <h2 className="contact-us">Bize Ulaşın </h2>
          <div className="u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
            <div className="u-layout">
              <div className="u-layout-row">
                <div className="u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                  <div className="u-container-layout u-valign-bottom u-container-layout-1">
                    <div className="u-expanded-width u-grey-light-2 u-map u-map-1">
                      <div className="embed-responsive">
                        {VirtualHost.companyMapLocation && ReactHtmlParser(VirtualHost.companyMapLocation)}
                      </div>
                    </div>
                    <h2 className="u-subtitle u-text u-text-custom-color-1 u-text-default u-text-2">
                      {" "}
                      {VirtualHost.companyAddressName}
                    </h2>
                    <p className="u-small-text u-text u-text-default u-text-variant u-text-3">
                      {" "}
                      {VirtualHost.companyAddress}<br/>
                      {VirtualHost.companyCitySubdivision + "/" + VirtualHost.companyCity}<br/>
                      {VirtualHost.companyTelephone}
                    </p>
                  </div>
                </div>
                <div className="u-container-style u-layout-cell u-size-30 u-layout-cell-2">
                  <div className="u-container-layout u-container-layout-2">
                    <div className="u-border-10 u-border-custom-color-1 u-border-no-left u-border-no-right u-border-no-top u-form u-grey-10 u-form-1">
                      <div
                        className="u-clearfix u-form-spacing-20 u-form-vertical u-inner-form"
                        style={{ padding: "20px" }}
                        name="form"
                      >
                        <div className="u-form-group u-form-name u-label-none u-form-group-1">
                          <label for="nameSurname" className="u-label">
                            Adınız Soyadınız
                          </label>
                          <input
                            type="text"
                            placeholder="Adınız Soyadınız"
                            id="nameSurname"
                            name="nameSurname"
                            className="u-border-1 u-border-grey-30 u-input u-input-rectangle u-radius-12 u-white"
                            required=""
                            onChange={(event) => {
                              setNameSurname(event.target.value)
                            }}
                            value={nameSurname}
                          />
                        </div>
                        <div className="u-form-email u-form-group u-label-none">
                          <label
                            for="email"
                            className="u-form-control-hidden u-label"
                          ></label>
                          <input
                            type="email"
                            placeholder="e-Posta adresiniz"
                            id="email"
                            name="email"
                            className="u-border-1 u-border-grey-30 u-input u-input-rectangle u-radius-12 u-white"
                            required={true}
                            onChange={(event) => {
                              setEmail(event.target.value)
                            }}
                            value={email}
                            onfocusout={() => validate()}
                          />
                        </div>
                        <div className="u-form-group u-form-phone u-label-none u-form-group-3">
                          <label for="phone" className="u-label">
                            Telefon Numaranız
                          </label>
                          <input
                            type="tel"
                            pattern="\+?\d{0,3}[\s\(\-]?([0-9]{2,3})[\s\)\-]?([\s\-]?)([0-9]{3})[\s\-]?([0-9]{2})[\s\-]?([0-9]{2})"
                            placeholder="Telefon Numaranız (örn. 532146789)"
                            id="phone"
                            min="10"
                            max="10"
                            name="phone"
                            className="u-border-1 u-border-grey-30 u-input u-input-rectangle u-radius-12 u-white"
                            required={true}
                            onChange={(event) => {
                              setPhone(event.target.value)
                            }}
                            value={phone}
                          />
                        </div>
                        <div className="u-form-group u-form-message u-label-none">
                          <label for="message" className="u-label">
                            Mesajınız
                          </label>
                          <textarea
                            placeholder="Mesajınızı Giriniz..."
                            rows="4"
                            cols="50"
                            id="message"
                            name="message"
                            className="u-border-1 u-border-grey-30 u-input u-input-rectangle u-radius-12 u-white"
                            required={true}
                            onChange={(event) => {
                              setMessage(event.target.value)
                            }}
                            value={message}
                          />
                        </div>
                        <Captcha />
                        <div className="u-align-center u-form-group u-form-submit" onClick={() => handleSubmit()}>
                          {loading && <LoadingIndicator/>}
                          {!loading && <a
                              href="#"
                              className="u-active-custom-color-6 u-border-none u-btn u-btn-round u-btn-submit u-button-style u-custom-color-1 u-hover-custom-color-2 u-radius-50 u-btn-1"
                          >Gönder
                          </a>}
                          {!loading && <button className="u-form-control-hidden"/>}
                        </div>
                        <div id="u-form-send-success" className="u-form-send-message u-form-send-success">
                          {" "}
                          Teşekkürler mesajınız gönderilmiştir! En kısa zamanda
                          size ulaşılacaktır.{" "}
                        </div>
                        <div id="u-form-send-error" className="u-form-send-message u-form-send-error">
                          {" "}
                          Mesajınız gönderilemedi. Lütfen hataları düzeltin ve
                          tekrar deneyin.{" "}
                        </div>
                        <input
                          type="hidden"
                          value=""
                          name="recaptchaResponse"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/page/contactUs/index.js